import '@elhub/ds-css'
import 'index.css'
import i18n from 'locales/i18n'
import reportWebVitals from 'reportWebVitals'
import store from 'store'

import * as Pages from 'pages'

import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'

import { worker } from './setupMocks'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Start the mocking conditionally.
if (process.env.NODE_ENV === 'development') {
  worker.start()
}

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Suspense fallback={<div>Loading...</div>}>
          <Router>
            <Routes>
              <Route path='/*' element={<Pages.Introduction />} />
              <Route path='/energy-data-api' element={<Pages.EnergyDataAPIs />} />
              <Route path='/data-export-api' element={<Pages.DataExportAPIs />} />
              <Route path='/downloads' element={<Pages.Downloads />} />
              <Route path='/maskinporten' element={<Navigate to='/maskinporten/getting-started' replace />} />
              <Route path='/maskinporten/:nav' element={<Pages.Maskinporten />} />
              <Route path='/terms-of-use' element={<Pages.TermsOfUse />} />
              <Route path='/change-logs' element={<Pages.ChangeLog />} />
              <Route path='/try-it-out' element={<Pages.TryItOut />} />
              <Route path='/terms-of-use' element={<Pages.TermsOfUse />} />
            </Routes>
          </Router>
        </Suspense>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
